<template>
  <div id="navModule">
    <el-menu
      :default-active="$route.fullPath"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
      unique-opened
    >
      <!-- navMenu -state -->
      <div v-for="item in $store.state.routers" :key="item.path">
        <el-menu-item
          :index="item.path"
          v-if="!item.children && item.render !== '0' && item.path !== ''"
          ><i class=""></i>{{ item.meta.title }}</el-menu-item
        >
        <el-submenu :index="item.path" v-else-if="item.render !== '0' && item.path !== ''">
          <template slot="title">
            <i class=""></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item-group>
            <div v-for="subItem in item.children" :key="subItem.path">
              <el-menu-item :index="subItem.path" v-if="subItem.render !== '0' && item.path !== ''">{{
                subItem.meta.title
              }}</el-menu-item>
            </div>
          </el-menu-item-group>
        </el-submenu>
      </div>
      <!-- navMenu -end -->
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "navModule",
  components: {},
  data() {
    return {};
  },
  created() {
  },
  methods: {

  },
};
</script>

<style>
#navModule .el-menu {
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/osNav/components/nav-left.vue